var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5.47368,
    fill: "#E1ECFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3848_711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 17,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.21094,
    y: 4.78955,
    width: 16.4211,
    height: 16.4211,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3848_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5702 19.1143L8.87811 13.4327C8.81408 13.3687 8.76891 13.3011 8.7426 13.2301C8.71628 13.159 8.70312 13.0823 8.70312 12.9998C8.70312 12.9173 8.71628 12.8406 8.7426 12.7695C8.76891 12.6985 8.81409 12.6309 8.87813 12.5669L14.5768 6.86823C14.7057 6.73928 14.8636 6.6748 15.0505 6.6748C15.2373 6.6748 15.4009 6.74498 15.5413 6.88534C15.6772 7.0213 15.7452 7.18138 15.7452 7.36558C15.7452 7.5498 15.6772 7.70988 15.5413 7.84585L10.3873 12.9998L15.5478 18.1603C15.6768 18.2893 15.7413 18.4454 15.7413 18.6287C15.7413 18.8121 15.6711 18.9739 15.5307 19.1143C15.3948 19.2502 15.2347 19.3182 15.0505 19.3182C14.8663 19.3182 14.7062 19.2502 14.5702 19.1143Z",
    fill: "#0060FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.52ff44f9f96da1d128ba5b1f105da71c.svg";
export { ForwardRef as ReactComponent };